var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge",class:{ 'gray-border': _vm.isDemo, 'border-green': !_vm.isDemo }},[_c('span',[_vm._v(" "+_vm._s(_vm.$t(`wallets.${_vm.isDemo ? 'demo' : 'live'}`).toUpperCase())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }